"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNhsNumber = formatNhsNumber;
exports.validateNhsNumber = validateNhsNumber;
const nhs_number_validator_1 = require("nhs-number-validator");
const Extensions_1 = require("./Extensions");
function formatNhsNumber(nhsNumber) {
    return (nhsNumber.slice(0, 3) + " " + nhsNumber.slice(3, 6) + " " + nhsNumber.slice(6, 10));
}
function validateNhsNumber(nhsNumber) {
    if (nhsNumber.length !== 10) {
        return Extensions_1.WrappedResult.Fail("Please enter a 10 digit NHS number");
    }
    if ((0, nhs_number_validator_1.validate)(nhsNumber) === false) {
        return Extensions_1.WrappedResult.Fail("Please enter a valid NHS number");
    }
    return Extensions_1.WrappedResult.Success({});
}
//# sourceMappingURL=NhsNumberHelper.js.map